import DomainPanel, { Content } from "components/domainPanel/DomainPanel";
import WebsitePreview from "components/websitePreview/WebsitePreview";
import moment from "moment";
import { memo, useMemo } from "react";
import DomainDetails from "types/domainDetails";

interface TakenDomainBodyProps {
  domainDetails: DomainDetails;
}

const TakenDomainBody = (props: TakenDomainBodyProps) => {
  const { domainDetails } = props;

  const creationDate = domainDetails.creation
    ? moment(domainDetails.creation)
    : undefined;

  const expirationDate = domainDetails.expires
    ? moment(domainDetails.expires)
    : undefined;

  // Calculate domain age
  const domainAge = useMemo(() => {
    if (!creationDate) return null;
    const years = moment().diff(creationDate, "years");
    const months = moment().diff(creationDate, "months") % 12;

    if (years > 0) {
      return months > 0
        ? `${years} year${years > 1 ? "s" : ""}, ${months} month${
            months > 1 ? "s" : ""
          }`
        : `${years} year${years > 1 ? "s" : ""}`;
    }
    return `${months} month${months > 1 ? "s" : ""}`;
  }, [creationDate]);

  // Calculate days until expiration
  const daysUntilExpiration = useMemo(() => {
    if (!expirationDate) return null;
    return expirationDate.diff(moment(), "days");
  }, [expirationDate]);

  const content: Content[] = [
    {
      title: "Registered On",
      description: creationDate?.format("DD MMMM YYYY") || "Unknown",
    },
    {
      title: "Domain Age",
      description: domainAge || "Unknown",
    },
    {
      title: "Expires On",
      description: expirationDate?.format("DD MMMM YYYY") || "Unknown",
    },
    {
      title: "Expiration Status",
      description: daysUntilExpiration
        ? daysUntilExpiration > 0
          ? `Expires in ${daysUntilExpiration} day${
              daysUntilExpiration !== 1 ? "s" : ""
            }`
          : daysUntilExpiration === 0
            ? "Expires today"
            : `Expired ${Math.abs(daysUntilExpiration)} day${
                Math.abs(daysUntilExpiration) !== 1 ? "s" : ""
              } ago`
        : "Unknown",
    },
  ].filter((item) => item.description !== "Unknown");

  // Schema markup is now handled at the page level
  // Removed duplicate schema to keep markup simple and compliant

  return (
    <>
      <DomainPanel title={"Registration Details"} details={content} />
      {domainDetails.renderedSnapshotFiles &&
        domainDetails.renderedSnapshotFiles.length > 0 && (
          <WebsitePreview
            domain={domainDetails.domain}
            snapshotFiles={domainDetails.renderedSnapshotFiles}
          />
        )}
    </>
  );
};

export default memo(TakenDomainBody);
